export default {
  name: 'create-children',
  components: {},
  props: ['parent'],
  data () {
    return {
      organization: {},
      errors: {},
      btn_submit: false
    }
  },
  computed: {
    show () {
      return this.$store.getters['Organization/getOpenCreateChildren']
    }
  },
  mounted () {
    this.organization = {}
    this.organization.parent_id = this.parent
    this.errors = {}
  },
  watch: {
    parent: function () {
      this.organization = {}
      this.organization.parent_id = this.parent
      this.errors = {}
    }
  },
  methods: {
    addOrganization () {
      this.$loading.start()
      this.btn_submit = true
      this.$store.dispatch('Organization/addOrganizationChidrent', {
        organization: this.organization
      }).then((res) => {
        this.btn_submit = false
        this.$loading.complete()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.create_success')
        })
        this.$store.dispatch('Organization/closeCreateChildren')
      }).catch((err) => {
        if (err.status === 422) {
          this.errors = err.data.error
        }
        this.btn_submit = false
        this.$loading.fail()
      })
    },
    cancel () {
      this.$store.dispatch('Organization/closeCreateChildren')
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/organization/create-children/create-children.js